<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 youtube-url="https://youtu.be/q2uY8F0c-lg"
                                 :has-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-top-border-anchor-link="false"
                                 :has-movie-title="false"
    >
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('feature_summary.png')" alt="Luvholiの基本情報">
        </template>
        <template v-slot:content-1>
            <p class="img-01"><img :src="buildImgUrl('contents_01_01.png')" alt="Point.01 きゅるんeye Point.02 パーツバランス"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_01_02.png')" alt="推し活するときは1番盛れてる私がいい！Luvholiでは、きゅるんeyeと甘めのパーツバランスで現場で大注目の可愛さに♡"></p>
        </template>
        <template v-slot:content-2>
            <p class="img-01"><img :src="buildImgUrl('contents_02_01.png')" alt="枠に当てはめるだけでバランスよく撮れるから推しも自分も超可愛く写る♡"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_02_02.png')" alt="さらに 様々なグッズに対応したサンプルポーズがあるから、ポーズを事前に決めていなくても安心！"></p>
        </template>
        <template v-slot:content-3>
            <p class="img-01"><img :src="buildImgUrl('contents_03.png')" alt="流行りのグッズだけの撮影が新しい！画角が広いから、大きなグッズも余裕で写せる♡"></p>
        </template>
        <template v-slot:content-4>
            <p class="img-01"><img :src="buildImgUrl('contents_04.png')" alt="推しの名前が読めないなんてイヤ！「反転お直し選択」を使うと反転しているプリ画を1枚ずつ選んで直せるよ！"></p>
        </template>
        <template v-slot:content-5>
            <p class="img-01"><img :src="buildImgUrl('contents_05_01.png')" alt="Luvholiならではのカラバリ豊富なペンとスタンプで推し活はかどる♡"></p>
            <p class="img-02"><img :src="buildImgUrl('contents_05_02.png')" alt="さらにシールデザインが充実！好きなデザインを推しのカラーにチェンジできちゃう♡"></p>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachineMyPalette2",
    components: { LayoutMachineIntroduction },
    data() {
        return {
            machineId: 157,
            sectionTitleList: [
                '01 ちょっぴり甘めで超盛れる♡ ピュアあま盛れ',
                '02 Luvholiならではの神機能！ グッズ枠',
                '03 プリなのに推しが主役！？ 「推しごと撮影」',
                '04 ネームボードが反転したら！ 反転お直し選択',
                '05 カラバリ豊富で超助かる♡ 落書き&シール',
            ],
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
    }
}
</script>

<style scoped lang="scss">
@use "../../../../scss/v2/base/variables";
@use "sass:math";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-puri-list {
                width: math.percentage(math.div(162px, $deviceWidth));
                top: math.percentage(math.div(200px, $deviceWidth));
                left: math.percentage(math.div(15px, $deviceWidth));
            }

            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(350px, $deviceWidth));
                width: 100%;
                &-link {
                    width: math.percentage(math.div(532px, $deviceWidth));
                }
            }
            .list-anchor-link-feature-summary {
                background-image: v-bind("buildStyleImgUrl('link_bk.png')");
                background-repeat: no-repeat;
                background-size: 100%;
            }
            .list-anchor-link {
                padding: (variables.$grid-base) 0 (variables.$grid-base) 0;

                .img-link {
                    width: math.percentage(math.div(654px, $deviceWidth));
                }

                .img-line {
                    width: math.percentage(math.div(654px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
            }

            .feature-summary {
                width: math.percentage(math.div(594px, $deviceWidth));
                padding: 0 0 (variables.$grid-base) 0;
                margin: auto;
            }
        }

        &-movie {
            padding: 21% 0 10%;
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            &-thumb {
                width: math.percentage(math.div(651px, $deviceWidth));
                margin: 0 auto;
            }
            &-btn-studio {
                width: math.percentage(math.div(420px, $deviceWidth));
                margin: 20px auto 0;
            }
        }
    }
}

</style>
